import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImagesListComponent } from './images-list/images-list.component';
import { AddNewImageComponent } from './modal/add-new-image/add-new-image.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RegistryManagementComponent } from './registry-management/registry-management.component';
import { RepositoryManagementComponent } from './repository-management/repository-management.component';
import { ResizableModule } from 'src/app/core/directive/resizable/resizable.module';
import { ImageManagementComponent } from './image-management/image-management.component';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { AngularMaterialModule } from 'src/app/shared/material-module';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../shared/shared.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NodeRoutingModule } from '../node/node-routing.module';
import { CoreModule } from 'src/app/core/core.module';
import { AngularSplitModule } from 'angular-split';
import { DynamicPaginationDirective } from 'src/app/core/directive/dynamicPagination/dynamic-pagination.directive';
import { BuildImageComponent } from './modal/build-image/build-image.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CreateRegistryComponent } from './modal/create-registry/create-registry.component';
import { CreateRepositoryComponent } from './modal/create-repository/create-repository.component';

@NgModule({
  declarations: [
    ImagesListComponent,
    AddNewImageComponent,
    RegistryManagementComponent,
    RepositoryManagementComponent,
    ImageManagementComponent,
    BuildImageComponent,
    CreateRegistryComponent,
    CreateRepositoryComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbModule,
    FormsModule,
    ResizableModule,
    AppRoutingModule,
    BrowserModule,
    AngularMaterialModule,
    NgxPaginationModule,
    SharedModule,
    NgxSpinnerModule,
    NodeRoutingModule,
    CoreModule,
    AngularSplitModule,
    DynamicPaginationDirective,
    CoreModule,
    NgbModule,
    NgSelectModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
    MatSlideToggleModule
  ]
})
export class ImagesModule { }
